module.exports = __webpack_public_path__ + "img/modal-usd-icon.7ce3eaaa.svg";